(function () {
  var nav = document.getElementById('journal-nav-inner');
  var grid = document.getElementById('journal-grid');
  var featured = document.getElementById('journal-featured');
  var empty = document.getElementById('journal-empty');
  var searchInput = document.getElementById('journal-search-input');
  var filterTitle = document.getElementById('journal-filter-title');
  var hero = document.querySelector('.journal-hero');

  if (!nav || !grid) return;

  var buttons = nav.querySelectorAll('.journal-nav__item');
  var cards = grid.querySelectorAll('.journal-card');
  var viewAllTriggers = document.querySelectorAll('.journal-viewall-trigger');
  var activeFilter = 'all';

  function getCardText(card) {
    var title = card.querySelector('.journal-card__title');
    var excerpt = card.querySelector('.journal-card__excerpt');
    var tags = card.getAttribute('data-tags') || '';
    return [
      title ? title.textContent : '',
      excerpt ? excerpt.textContent : '',
      tags
    ].join(' ').toLowerCase();
  }

  function getFilterLabel(filter) {
    var label = null;
    buttons.forEach(function (b) {
      if (b.getAttribute('data-filter') === filter) {
        label = b.textContent;
      }
    });
    return label;
  }

  function applyFilters() {
    var searchTerm = searchInput ? searchInput.value.toLowerCase().trim() : '';
    var visible = 0;

    cards.forEach(function (card) {
      var tagMatch = false;
      var searchMatch = false;

      if (activeFilter === 'all') {
        tagMatch = true;
      } else {
        var rawTags = (card.getAttribute('data-tags') || '').toLowerCase();
        var tagList = rawTags.split(/\s+/).filter(Boolean);
        tagMatch = tagList.indexOf(activeFilter.toLowerCase()) !== -1;
      }

      if (searchTerm === '') {
        searchMatch = true;
      } else {
        searchMatch = getCardText(card).indexOf(searchTerm) !== -1;
      }

      if (tagMatch && searchMatch) {
        card.classList.remove('is-hidden');
        visible++;
      } else {
        card.classList.add('is-hidden');
      }
    });

    if (empty) {
      empty.style.display = visible === 0 ? 'block' : 'none';
    }
  }

  function updateView() {
    var searchTerm = searchInput ? searchInput.value.toLowerCase().trim() : '';
    var showFeatured = activeFilter === 'all' && searchTerm === '';

    if (featured) {
      featured.style.display = showFeatured ? '' : 'none';
    }
    if (hero) {
      hero.style.display = showFeatured ? '' : 'none';
    }
    grid.style.display = showFeatured ? 'none' : '';

    if (filterTitle) {
      if (!showFeatured && activeFilter !== 'all') {
        filterTitle.textContent = getFilterLabel(activeFilter) || activeFilter;
        filterTitle.style.display = 'block';
      } else {
        filterTitle.style.display = 'none';
      }
    }

    if (showFeatured) {
      if (empty) empty.style.display = 'none';
      return;
    }

    applyFilters();
  }

  function setActiveButton(filter) {
    buttons.forEach(function (b) {
      b.classList.toggle('is-active', b.getAttribute('data-filter') === filter);
    });
  }

  buttons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      activeFilter = btn.getAttribute('data-filter');
      setActiveButton(activeFilter);
      updateView();
    });
  });

  viewAllTriggers.forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      activeFilter = trigger.getAttribute('data-filter');
      setActiveButton(activeFilter);
      if (searchInput) searchInput.value = '';
      updateView();
      nav.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  if (searchInput) {
    searchInput.addEventListener('input', updateView);
  }

  var urlParams = new URLSearchParams(window.location.search);
  var filterParam = urlParams.get('filter');
  if (filterParam) {
    var normalizedParam = filterParam.toLowerCase();
    var matchFound = false;
    buttons.forEach(function (b) {
      if (b.getAttribute('data-filter') === normalizedParam) {
        matchFound = true;
      }
    });
    if (matchFound) {
      activeFilter = normalizedParam;
      setActiveButton(activeFilter);
    }
  }

  updateView();
})();